module.exports = __webpack_public_path__ + "static/media/windFace.467d5375.png";